// src/modules/app-views/omnichannel/pages/Init/modals/OmnichannelParametersModal/modals/AddWhatsappModal/Step1.jsx
// *******************************************************************************
// Step 1: Display name, phone number and source selection (Meta or Unofficial)
// *******************************************************************************
import { WhatsAppOutlined } from '@ant-design/icons';
import SimpleInput from 'components/SimpleComponents/SimpleInput';
import SimplePhone from 'components/SimpleComponents/SimplePhone';
import SimpleSelect from 'components/SimpleComponents/SimpleSelect';
import translateX from 'utils/translateX';

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const Step1Content = ({ isEditing, lockedSource, disabled }) => (
  <>
    <SimpleInput
      name="displayName"
      label="display_name"
      placeholder={translateX('display_name_placeholder')}
      required
      maxLength={80}
      autoFocus
    />

    <SimplePhone
      name={['phoneNumber', 'value']}
      label="phone"
      international
      required
      disabled={isEditing}
    />

    <SimpleSelect
      name="sourceType"
      label="origin"
      required
      showSearch={false}
      allowClear={false}
      placeholder={translateX('select_origin')}
      disabled={isEditing || !!lockedSource || disabled}
      options={[
        { value: 'meta', label: 'WhatsApp Oficial Meta' },
        { value: 'baileys', label: 'WhatsApp Não Oficial' },
      ]}
      optionRender={option => (
        <span>
          <WhatsAppOutlined
            style={{ color: option.value === 'meta' ? '#25D366' : '#FF9800', marginRight: 6 }}
          />
          {option.label}
        </span>
      )}
      labelRender={props => (
        <span>
          <WhatsAppOutlined
            style={{ color: props.value === 'meta' ? '#25D366' : '#FF9800', marginRight: 6 }}
          />
          {props.label}
        </span>
      )}
    />
  </>
);

// *******************************************************************************
// STEP BUILDER
// *******************************************************************************
const step1 = ({ isEditing = false, lockedSource = null, disabled = false } = {}) => ({
  stepTitle: 'phone_data',
  stepTooltip: 'whatsapp_phone_info',
  content: () => <Step1Content isEditing={isEditing} lockedSource={lockedSource} disabled={disabled} />,
  validationFields: ['displayName', 'sourceType'],
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default step1;
